module.exports = __webpack_public_path__ + "img/nopaid.0170c601.png";